export default __webpack_public_path__ + "static/media/8.3651f012.jpg";